var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app"
  }, [_vm.item.productStatus === 0 || _vm.item.productStatus === 2 ? _c("div", {
    staticClass: "mask"
  }, [_c("p", [_vm._v(_vm._s(_vm.$t("productDetail.btnProductStatus")))])]) : _vm.item.productStockNum === 0 ? _c("div", {
    staticClass: "mask"
  }, [_c("p", [_vm._v(_vm._s(_vm.replenishment))])]) : _vm._e(), _c("div", {
    staticClass: "box_content"
  }, [_c("div", {
    staticClass: "img"
  }, [_c("YYImage", {
    staticClass: "yyImg",
    staticStyle: {
      width: "172px",
      height: "172px"
    },
    attrs: {
      src: _vm.item.host + _vm.item.productImage
    }
  })], 1), _vm.item.productPointNum > 0 && _vm.item.productStatus == 1 ? _c("div", {
    staticClass: "pointTab top_left_tag"
  }, [_c("div", {
    staticClass: "tabLeft"
  }), _c("div", {
    staticClass: "tabMiddle"
  }, [_vm._v(_vm._s(_vm.$t("my_collection.reward_points", {
    num: _vm.item.productPointNum
  })))]), _c("div", {
    staticClass: "tabRight"
  })]) : _vm._e(), _c("span", {
    staticClass: "top_right_tag"
  }, [_vm._v(_vm._s(_vm.item.transportName))]), _c("div", {
    staticClass: "price"
  }, [_c("div", [_c("div", {
    class: [_vm.systemInfo ? "ios_common_style" : "android_common_style", {
      first_price_active: _vm.item.productOriginalPrice !== _vm.item.productDiscountPrice,
      first_price: _vm.item.productOriginalPrice === _vm.item.productDiscountPrice
    }]
  }, [_vm.item.productOriginalPrice > 0 ? _c("div", {
    staticClass: "discount",
    domProps: {
      innerHTML: _vm._s(_vm.$checkPrice(_vm.item.productOriginalPrice))
    }
  }) : _vm._e()]), _vm.item.productOriginalPrice !== _vm.item.productDiscountPrice ? _c("span", {
    staticClass: "arrow"
  }, [_vm._v("→")]) : _vm._e(), _vm.item.productOriginalPrice !== _vm.item.productDiscountPrice ? _c("div", {
    class: [_vm.systemInfo ? "ios_common_style" : "android_common_style", "second_active"]
  }, [_vm.item.productDiscountPrice > 0 ? _c("div", {
    staticClass: "discount",
    domProps: {
      innerHTML: _vm._s(_vm.$checkPrice(_vm.item.productDiscountPrice))
    }
  }) : _vm._e()]) : _vm._e()]), _vm.type === 2 ? _c("div", {
    staticClass: "cart_icon"
  }, [_c("svg", {
    staticClass: "icon cart",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.addCart.apply(null, arguments);
      }
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-32-ShoppingCart1"
    }
  })])]) : _vm._e()]), _c("div", {
    class: ["name", _vm.systemInfo ? "ios_common_style" : "android_common_style"]
  }, [_vm.item.bundle === 1 ? _c("span", {
    staticClass: "bundling_tag"
  }, [_vm._v(_vm._s(_vm.$t("my_collection.bunding")))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.productName) + " ")]), _c("div", {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.item.productSpecification) + " ")]), _vm.item.productOnlineTag || _vm.item.bargainStatus === 1 || _vm.item.productStockNumTag || _vm.item.productChannelTag ? _c("div", {
    staticClass: "bottom_first_row"
  }, [_vm.item.productOnlineTag ? _c("span", [_vm._v(_vm._s(_vm.item.productOnlineTag))]) : _vm._e(), _vm.item.bargainStatus === 1 ? _c("span", [_vm._v(_vm._s(_vm.disposals))]) : _vm._e(), _vm.item.productStockNumTag ? _c("span", [_vm._v(_vm._s(_vm.item.productStockNumTag))]) : _vm._e(), _vm.item.productChannelTag ? _c("span", [_vm._v(_vm._s(_vm.item.productChannelTag))]) : _vm._e()]) : _vm._e(), _vm.item.couponTypeList ? _c("div", {
    staticClass: "bottom_last_row"
  }, [_vm.item.bottom_last_row_tag3 ? _c("span", [_vm._v(_vm._s(_vm.full_coupon_reduction))]) : _vm._e(), _vm.item.bottom_last_row_tag2 ? _c("span", [_vm._v(_vm._s(_vm.full_discount_coupon))]) : _vm._e(), _vm.item.bottom_last_row_tag4 ? _c("span", [_vm._v(_vm._s(_vm.parcel_post_voucher))]) : _vm._e()]) : _vm._e(), _vm.type === 1 ? _c("div", {
    staticClass: "icon_group"
  }, [_c("svg", {
    staticClass: "icon cart",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.addCart.apply(null, arguments);
      }
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-32-ShoppingCart1"
    }
  })]), _c("svg", {
    staticClass: "icon del",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.cancel.apply(null, arguments);
      }
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-delete"
    }
  })])]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };